import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { FormChipField } from '@common/ui/forms/input-field/chip-field/form-chip-field';
import { Item } from '@common/ui/forms/listbox/item';
import { useTrans } from '@common/i18n/use-trans';
import { Checkbox } from '@common/ui/forms/toggle/checkbox';

export interface SheetItem {
  name: string;
  check: boolean;
  loan_program_types: string[];
  data: any[];
  status: string;
  md_data: any[];
}

interface RowSheetNameProps {
  pidx: number;
  index: number;
  sheet_item: SheetItem;
  investor_code: string;
  loan_program_types: string[];
  selectedSheetNames: string[];
  setSelectedSheetNames: (names: string[]) => void;
  selectedLoanProgramTypes: { sheetName: string; types: string[] }[];
  setSelectedLoanProgramTypes: (selections: { sheetName: string; types: string[] }[]) => void;
}
export function RowSheetName({
  pidx,
  index,
  sheet_item,
  investor_code,
  loan_program_types,
  selectedSheetNames,
  setSelectedSheetNames,
  selectedLoanProgramTypes,
  setSelectedLoanProgramTypes,
}: RowSheetNameProps) {
  const { trans } = useTrans();
  const { register, watch, setValue } = useFormContext<any>();
  const sheet_name = sheet_item['name'];
  const isChecked = selectedSheetNames.includes(sheet_name); // Only use selectedSheetNames

  const handleCheckboxChange = (checked: boolean) => {
    if (checked) {
      setSelectedSheetNames([...selectedSheetNames, sheet_name]);
    } else {
      setSelectedSheetNames(selectedSheetNames.filter((name) => name !== sheet_name));
    }
  };

  const watchedTypes = watch(`${pidx}_${index}_loan_program_types`);

  let val: any[] = [];
  try {
    val = watchedTypes instanceof Object ? [watchedTypes] : (watchedTypes ? JSON.parse(watchedTypes) : sheet_item['loan_program_types'] || []);
  } catch (e) {
    console.error("Failed to parse watchedTypes:", e);
    val = sheet_item['loan_program_types'] || [];
  }

  const setInputValue = (items: { id: any }[]) => {
    const selectedTypes = items.map(item => item.id);
    const updatedSelections = [...selectedLoanProgramTypes];
    
    const existingIndex = updatedSelections.findIndex(selection => selection.sheetName === sheet_name);
    if (existingIndex !== -1) {
      updatedSelections[existingIndex] = { sheetName: sheet_name, types: selectedTypes };
    } else {
      updatedSelections.push({ sheetName: sheet_name, types: selectedTypes });
    }

    setSelectedLoanProgramTypes(updatedSelections);

    setValue(`${pidx}_${index}_loan_program_types`, JSON.stringify(selectedTypes), {
      shouldDirty: true,
    });
  };

  return (
    <div className="flex items-center gap-8 py-4 ">
        <Checkbox
          size='md'
          checked={isChecked}
          onChange={(e) => handleCheckboxChange(e.target.checked)}
        >
          {sheet_name}
        </Checkbox>
        <FormChipField
          className="mb-10 mt-10"
          name={`${pidx}_${index}_loan_program_types`}
          value={val}
          onChange={setInputValue}
        >
          {loan_program_types?.map((type: string) => (
            <Item value={type} key={type}>
              <Trans message={type} />
            </Item>
          ))}
        </FormChipField>
      
    </div>
  );
}